// extracted by mini-css-extract-plugin
export default {"productGrid":"rZ-z","centerLink":"sZ-z","productSection":"tZ-z","item":"uZ-z","ctaButton":"vZ-z"};